<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="15px"
      height="15px"
      viewBox="0 0 470.083 470.083"
      style="enable-background:new 0 0 470.083 470.083;"
      xml:space="preserve"
    >
      <path
        d="M434.961,270.163c0,110.241-89.684,199.92-199.923,199.92c-110.235,0-199.917-89.679-199.917-199.92   c0-36.44,9.915-72.129,28.658-103.178l52.163,31.487c-13.013,21.56-19.89,46.353-19.896,71.697   c0,76.64,62.35,138.985,138.985,138.985c76.642,0,138.989-62.346,138.989-138.985c0-73.864-57.961-134.275-130.759-138.566h-29.808   l25.1,63.541c0.843,2.128,0.16,4.558-1.669,5.932c-1.827,1.38-4.351,1.374-6.168-0.026l-124.806-95.965   c-1.25-0.966-1.989-2.444-1.989-4.037c0-1.584,0.739-3.074,1.989-4.037L230.724,1.052C231.64,0.346,232.727,0,233.824,0   c1.082,0,2.154,0.34,3.068,1.022c1.829,1.374,2.512,3.807,1.669,5.938l-25.1,63.534l21.586-0.254c7.72,0,33.325,2.598,37.545,3.591   C364.931,91.46,434.961,172.766,434.961,270.163z"
        fill="#f88"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.icon {
  animation: rotate 7s linear infinite;
  display: inline-block;
}

@keyframes rotate {
  to {
    transform: rotate(-360deg);
  }
}
</style>
